// $(document).ready(function(){
	$('.review-slider').slick({
 	  arrows:false,
		dots:true,
		slidesToShow:1,
		autoplay:true,
		speed:1000,
		autoplaySpeed:2000
	});
// });

